import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect as useScrollEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PageTransition from './components/PageTransition';
import Home from './pages/Home';
import Story from './pages/Story';
import Recipes from './pages/Recipes';
import RecipeDetails from './pages/RecipeDetails';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/BlogDetails';
import Contact from './pages/Contact';
import './App.css';

import { infoData } from './data/info';
import InfoPage from './pages/InfoPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useScrollEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <div className="noise-overlay" />
      <Cursor />
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<PageTransition><Home /></PageTransition>} />
          <Route path="/story" element={<PageTransition><Story /></PageTransition>} />
          <Route path="/recipes" element={<PageTransition><Recipes /></PageTransition>} />
          <Route path="/recipe/:id" element={<PageTransition><RecipeDetails /></PageTransition>} />
          <Route path="/products" element={<PageTransition><Products /></PageTransition>} />
          <Route path="/product/:id" element={<PageTransition><ProductDetails /></PageTransition>} />
          <Route path="/blogs" element={<PageTransition><Blogs /></PageTransition>} />
          <Route path="/blog/:id" element={<PageTransition><BlogDetails /></PageTransition>} />
          <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
          
          {/* Informational Routes */}
          <Route path="/farmers" element={<PageTransition><InfoPage {...infoData.farmers} /></PageTransition>} />
          <Route path="/process" element={<PageTransition><InfoPage {...infoData.process} /></PageTransition>} />
          <Route path="/faqs" element={<PageTransition><InfoPage {...infoData.faqs} /></PageTransition>} />
          <Route path="/privacy-policy" element={<PageTransition><InfoPage {...infoData.privacy} /></PageTransition>} />
          <Route path="/terms" element={<PageTransition><InfoPage {...infoData.terms} /></PageTransition>} />
          <Route path="/sitemap" element={<PageTransition><InfoPage {...infoData.sitemap} /></PageTransition>} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
